import { render } from "./Timestamp.vue?vue&type=template&id=d962344c&scoped=true"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"

import "./Timestamp.vue?vue&type=style&index=0&id=d962344c&scoped=true&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d962344c"]])

export default __exports__